module.exports = __webpack_public_path__ + "static/media/Imagegrey.7c6c40e7.svg";